import { userInfo } from '@/api/user/user'
const state = {
  experimentList: [],
  course_id: '',
  question_title: '',
  question_time: '',
  selectQuestion_Id: '',
  questionShow: 0,
  report_Id: ''
}

const mutations = {
  SET_EXPLIST(state, val) {
    state.experimentList = val
  },
  SET_CURSEID(state, val) {
    state.course_id = val
  },
  SET_QUESTION_ID(state, val) {
    state.selectQuestion_Id = val
  },
  SET_QUESTION_TITLE(state, val) {
    state.question_title = val
  },
  SET_QUESTION_TIME(state, val) {
    state.question_time = val
  },
  SET_QUESTIONSHOW(state, val) {
    state.questionShow = val
  },
  SET_REPORT_ID(state, val) {
    state.report_Id = val
  }
}

const actions = {
  setQuestionShowAsync: (context) => {
    userInfo().then(res => {
      const { questionShow } = res.data
      context.commit('SET_QUESTIONSHOW', questionShow)
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
